import { useEffect } from 'react';

export const useNavbarControl = (setShowNavbar, setShowTabsFooter) => {
  useEffect(() => {
    // Cacher la navbar et footer au montage
    setShowNavbar(false);
    setShowTabsFooter(false);

    // Restaurer lors du démontage
    return () => {
      setShowNavbar(true);
      setShowTabsFooter(true);
    };
  }, [setShowNavbar, setShowTabsFooter]);
};
